// extracted by mini-css-extract-plugin
export var cardIcon = "_4m-4";
export var checkboxCard = "_4m-0";
export var checkboxCardSelected = "_4m-3";
export var disabled = "_4m-1";
export var outerBorder = "_4m-2";
export var spacerMedium = "_4m-7";
export var spacerSmall = "_4m-6";
export var spacerXsmall = "_4m-5";